import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerRoleService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CustomerRoleListDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { resolveTenantScope, type TenantScope } from '../../constants/tenantScope';
import { type TableParamsType } from '../../types/common';

const useGetRoleList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filterCustomValue: string[],
  scopeOverride?: TenantScope
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CustomerRoleListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, scope } = tableInfo;
  const resolvedScope = resolveTenantScope(scopeOverride ?? scope);

  const rolesData = useQuery(
    ['getRoles', filterCustomValue, resolvedScope, filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        CustomerRoleService.getApiCustomerApiAppCustomerRoleCustomerRole(
          filterCustomValue,
          resolvedScope,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return rolesData;
};

export default useGetRoleList;
